import { render, staticRenderFns } from "./CopyComponents.vue?vue&type=template&id=ff8edd1c&scoped=true"
import script from "./CopyComponents.vue?vue&type=script&lang=js"
export * from "./CopyComponents.vue?vue&type=script&lang=js"
import style0 from "./CopyComponents.vue?vue&type=style&index=0&id=ff8edd1c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff8edd1c",
  null
  
)

export default component.exports